// import Date from 'datejs';
// return [{
//     PLANTID: input.PLANTID,
//     DATE: "01/01/2024",
//     SUNRISE: "01/01/2024 06:45:00",
//     SUNSET: "01/01/2024 17:33:40",
// }];
import moment from 'moment'

const degreesToRadians = degrees => {
  var pi = Math.PI
  return degrees * (pi / 180)
}

const radiansToDegrees = radians => {
  var pi = Math.PI
  // console.log(radians * (180 / pi));
  return radians * (180 / pi)
}

const calculateJulianDay = (eDate, localTime, timeZone) => {
  const date = eDate

  // Calculate Julian day
  const julianDay = date.getTime() / 86400000 + 2440587.5

  // Adjust for time and timezone
  const fractionalDay = localTime / 24
  const adjustedJulianDay = julianDay + fractionalDay - timeZone / 24

  return adjustedJulianDay.toFixed(2)
}

export const calculateSunriseSunset = (
  latitude,
  longitude,
  year,
  localTime,
  timeZone,
  plantId,
  entityId,
  daylightSaving
) => {
  const result = []
  const startDate = new Date(year, 0, 1)
  const endDate = new Date(year, 11, 31)
  // console.log(typeof(latitude), typeof(longitude), typeof(year), typeof(localTime), typeof(timeZone), typeof(plantId), typeof(entityId));

  for (
    let date = new Date(startDate);
    date <= endDate;
    date = new Date(date.getTime() + 86400000)
  ) {
    const julianDay = calculateJulianDay(date, localTime, timeZone)
    // console.log("julianDay",julianDay);

    const julianCentury = (julianDay - 2451545) / 36525
    // console.log("julianCentury",julianCentury);

    const gmls =
      (280.46646 + julianCentury * (36000.76983 + julianCentury * 0.0003032)) %
      360
    // console.log("gmls",gmls);

    const gmas =
      357.52911 + julianCentury * (35999.05029 - 0.0001537 * julianCentury)
    // console.log("gmas",gmas);

    const eeo =
      0.016708634 - julianCentury * (0.000042037 + 0.0000001267 * julianCentury)
    // console.log("eeo",eeo);

    const seqctr =
      Math.sin(degreesToRadians(gmas)) *
        (1.914602 - julianCentury * (0.004817 + 0.000014 * julianCentury)) +
      Math.sin(degreesToRadians(2 * gmas)) *
        (0.019993 - 0.000101 * julianCentury) +
      Math.sin(degreesToRadians(3 * gmas)) * 0.000289
    // console.log("seqctr",seqctr);

    const stl = gmls + seqctr
    // console.log("stl",stl);

    // const sta = gmas + seqctr;
    // console.log("sta",sta);

    const sal =
      stl -
      0.00569 -
      0.00478 * Math.sin(degreesToRadians(125.04 - 1934.136 * julianCentury))
    // console.log("sal", sal);

    const moe =
      23 +
      (26 +
        (21.448 -
          julianCentury *
            (46.815 + julianCentury * (0.00059 - julianCentury * 0.001813))) /
          60) /
        60
    // console.log("moe",moe);

    const oc = moe + 0.00256 * Math.cos(125.04 - 1934.136 * julianCentury)
    // console.log("oc",oc);

    const sd = radiansToDegrees(
      Math.asin(
        Math.sin(degreesToRadians(oc)) * Math.sin(degreesToRadians(sal))
      )
    )
    // console.log("sd",sd);

    const y =
      Math.tan(degreesToRadians(oc / 2)) * Math.tan(degreesToRadians(oc / 2))
    // console.log("y",y);

    const eqt =
      4 *
      radiansToDegrees(
        y * Math.sin(2 * degreesToRadians(gmls)) -
          2 * eeo * Math.sin(degreesToRadians(gmas)) +
          4 *
            eeo *
            y *
            Math.sin(degreesToRadians(gmas)) *
            Math.cos(2 * degreesToRadians(gmls)) -
          0.5 * y * y * Math.sin(4 * degreesToRadians(gmls)) -
          1.25 * eeo * eeo * Math.sin(2 * degreesToRadians(gmas))
      )
    // console.log(eqt);

    const has = radiansToDegrees(
      Math.acos(
        Math.cos(degreesToRadians(90.833)) /
          (Math.cos(degreesToRadians(latitude)) *
            Math.cos(degreesToRadians(sd))) -
          Math.tan(degreesToRadians(latitude)) * Math.tan(degreesToRadians(sd))
      )
    )
    // console.log("has",has);

    const sn = (720 - 4 * longitude - eqt + timeZone * 60) / 1440
    // console.log("sn",sn, "has", has);
    const dstOffset =
      daylightSaving === 'Y' &&
      moment
        .tz(date, 'America/New_York')
        .add(1, 'days')
        .isDST()
        ? 1
        : 0
    const sunriseTimeCal = (sn * 1440 - has * 4) / 60 + dstOffset
    let sunriseTimeHours = Number.parseInt(sunriseTimeCal)
    let sunriseTimeMinutes =
      Math.abs(sunriseTimeCal.toFixed(2) - Number.parseInt(sunriseTimeCal)) * 60
    if (parseInt(sunriseTimeMinutes) >= 60) {
      sunriseTimeHours += 1
      sunriseTimeMinutes = sunriseTimeMinutes.toFixed(2) - 60
    }
    let sunriseTimeSeconds = parseInt(
      Math.abs(
        sunriseTimeMinutes.toFixed(2) - Number.parseInt(sunriseTimeMinutes)
      ) * 60
    )
    if (parseInt(sunriseTimeSeconds) >= 60) {
      sunriseTimeMinutes += 1
      sunriseTimeSeconds = sunriseTimeSeconds.toFixed(2) - 60
      if (parseInt(sunriseTimeMinutes) >= 60) {
        sunriseTimeHours += 1
        sunriseTimeMinutes = 0
      }
    }
    sunriseTimeMinutes = parseInt(sunriseTimeMinutes)

    const sunsetTimeCal = (sn * 1440 + has * 4) / 60 + dstOffset
    let sunsetTimeHours = Number.parseInt(sunsetTimeCal)
    let sunsetTimeMinutes =
      Math.abs(sunsetTimeCal.toFixed(2) - Number.parseInt(sunsetTimeCal)) * 60
    if (parseInt(sunsetTimeMinutes) >= 60) {
      sunsetTimeHours += 1
      sunsetTimeMinutes = sunsetTimeMinutes.toFixed(2) - 60
    }
    let sunsetTimeSeconds = parseInt(
      Math.abs(
        sunsetTimeMinutes.toFixed(2) - Number.parseInt(sunsetTimeMinutes)
      ) * 60
    )
    if (parseInt(sunsetTimeSeconds) >= 60) {
      sunsetTimeMinutes += 1
      sunsetTimeSeconds = sunsetTimeSeconds.toFixed(2) - 60
      if (parseInt(sunsetTimeMinutes) >= 60) {
        sunsetTimeHours += 1
        sunsetTimeMinutes = 0
      }
    }
    sunsetTimeMinutes = parseInt(sunsetTimeMinutes)
    //  console.log(sunriseTimeHours);
    // console.log(sunriseTimeCal.toFixed(4),sunriseTimeCal.toFixed(2))
    // console.log(sunsetTimeHours, sunsetTimeMinutes, sunsetTimeSeconds)
    const sunriseTime =
      (sunriseTimeHours + '').padStart(2, '0') +
      ':' +
      (sunriseTimeMinutes + '').padStart(2, '0') +
      ':' +
      (sunriseTimeSeconds + '').padStart(2, '0')
    const sunsetTime =
      (sunsetTimeHours + '').padStart(2, '0') +
      ':' +
      (sunsetTimeMinutes + '').padStart(2, '0') +
      ':' +
      (sunsetTimeSeconds + '').padStart(2, '0')
    //  console.log(typeof sunriseTimeHours,typeof sunriseTimeMinutes, (sunriseTimeHours + ""), (sunriseTimeHours + "").padStart(2, '0'), sunriseTime)
    const mm = (date.getMonth() + 1 + '').padStart(2, '0') // 9   (PS: use +1 since Month returns 0-based index)
    const dd = (date.getDate() + '').padStart(2, '0') // 30
    const yyyy = date.getFullYear() // 2020
    result.push({
      plantId: plantId,
      entityId: entityId,
      transDate: yyyy + '-' + mm + '-' + dd,
      sunrise: yyyy + '-' + mm + '-' + dd + 'T' + sunriseTime,
      sunset: yyyy + '-' + mm + '-' + dd + 'T' + sunsetTime,
    })

    // result.push({ date: date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }), sunrise: sunriseTime, sunset: sunsetTime });
    // console.log("Date: - " + date + " SunriseTime: - " + sunriseTime + " SunsetTiem: - " + sunsetTime);
  }

  return result
}

// console.log(calculateSunriseSunset(latitude, longitude, year, localTime, timeZone));
